// extracted by css-extract-rspack-plugin
export default {"AdminNavbarRoot":"AdminNavbar-module__AdminNavbarRoot___fYu4N","AdminNavLink":"AdminNavbar-module__AdminNavLink___hGRox"};